var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 26,
    viewBox: "0 0 64 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6167 26C12.265 26 11.9134 25.8665 11.6358 25.5806L0.402512 14.0081C-0.134171 13.4552 -0.134171 12.5401 0.402512 11.9872L11.6358 0.414665C12.1725 -0.138222 13.0608 -0.138222 13.5975 0.414665C14.1342 0.967553 14.1342 1.88268 13.5975 2.43556L3.34501 12.9976L13.5975 23.5597C14.1342 24.1126 14.1342 25.0277 13.5975 25.5806C13.3384 25.8665 12.9683 26 12.6167 26Z",
    fill: "#C4AB73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3813 14H2.61866C1.18713 14 0 13.5467 0 13C0 12.4533 1.18713 12 2.61866 12H61.3813C62.8129 12 64 12.4533 64 13C64 13.5467 62.8129 14 61.3813 14Z",
    fill: "#C4AB73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLg);
export default __webpack_public_path__ + "static/media/arrowLg.f75c7afb9e1f41e0463b85876f5b2a4c.svg";
export { ForwardRef as ReactComponent };